
























































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import * as s_Interface from '@/interface/store/profile';
import * as c_Interface from '@/interface/components/profile';

const namespace: string = 'profile';

@Component
export default class ChangeProfile extends Vue {
  @Action('uploadThumb', { namespace }) c_uploadThumb!: any;
  @Action('deleteAvatar', { namespace }) c_deleteAvatar!: any;
  @Action('updateProfile', { namespace }) c_updateProfile!: any;
  @Action('getAvatar', { namespace }) c_getAvatar!: any;
  @Action('signS3', { namespace }) c_signS3!: any;
  @Action('getMembers', { namespace: 'manageGroup' }) c_getMembers!: any;
  @Action('getGroups', { namespace: 'manageGroup' }) c_getGroups!: any;
  @Action('deleteProfile', { namespace }) c_deleteProfile!: any;
  @Action('logOut', { namespace: 'auth' }) c_logOut!: any;

  @Getter('getterAuthUserId', { namespace: 'auth' }) c_getterAuthUserId!: string;
  @Getter('getterUser', { namespace }) c_getterUser!: {
    id: string;
    fullName: string;
    email: string;
    phoneNumber: string;
    organization: string;
    position: string;
  };
  @Getter('getterAvatar', { namespace }) c_getterAvatar!: s_Interface.Avatar;
  @Getter('getterLastGroupId') c_getterLastGroupId!: string;
  @Getter('getterGroupsMemberships', { namespace: 'manageGroup' }) c_getterGroupsMemberships!: any;

  public userPayload: c_Interface.ChangeProfilePayload = {
    id: '',
    fullName: '',
    email: '',
    phoneNumber: '',
    organization: '',
    position: '',
  };
  public imageUrl: string = '';
  public imageName: string = '';
  public file: any = null;

  public options: Array<c_Interface.positionOption> = [
    { label: '대학원생/박사', value: '대학원생/박사' },
    { label: '실험실 관리자', value: '실험실 관리자' },
    { label: '실험 테크니션', value: '실험 테크니션' },
    { label: '교수', value: '교수' },
    { label: '연구 과학자', value: '연구 과학자' },
    { label: '기타', value: '기타' },
  ];

  async created() {
    try {
      await this.c_getGroups();
      await this.c_getAvatar(this.c_getterAuthUserId);
      this.imageUrl = this.c_getterAvatar.url;
      this.imageName = this.c_getterAvatar.name;
      Object.assign(this.userPayload, this.c_getterUser);
    } catch (e) {
      console.log(e);
    }
  }

  async profileUpdateSave() {
    try {
      await this.c_updateProfile({
        userId: this.c_getterAuthUserId,
        payload: this.userPayload,
      });
      if (this.c_getterLastGroupId) await this.c_getMembers(this.c_getterLastGroupId);
      this.$message.success('프로필을 변경하였습니다.');
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  profileUpdateCancel() {
    let lastGroupId: string = 'welcome';
    if (this.c_getterLastGroupId !== null) lastGroupId = this.c_getterLastGroupId;
    this.$router.push({
      name: 'Container',
      params: {
        groupId: lastGroupId,
      },
    });
  }

  uploadHandle(): void {
    (this.$refs.file as HTMLFormElement).click();
  }

  uploadValidate(): boolean {
    if (this.file.size > 1024 * 1024 * 2) {
      this.$message.error('2MB 이내의 파일을 올려주세요.');
      return false;
    }
    if (this.file.type !== 'image/jpeg' && this.file.type !== 'image/png') {
      this.$message.error('지원하지 않는 파일형식입니다.');
      return false;
    }
    return true;
  }

  async deleteThumb(): Promise<any> {
    try {
      await this.c_deleteAvatar({
        userId: this.c_getterAuthUserId,
        fileName: this.imageName,
      });
      this.imageUrl = '';
      this.$message.success('프로필 사진을 삭제하였습니다.');
    } catch (e) {
      this.$message.error(e.response.data.error.message);
    }
  }

  async uploadFile(changeEvent: any): Promise<any> {
    this.file = changeEvent.target.files[0];
    if (!this.uploadValidate()) return false;
    try {
      await this.c_signS3({
        userId: this.c_getterAuthUserId,
        file: this.file,
      });
      await this.c_uploadThumb({
        userId: this.c_getterAuthUserId,
        file: this.file,
      });
      await this.c_getAvatar(this.c_getterAuthUserId);
      this.imageUrl = this.c_getterAvatar.url;
      this.imageName = this.c_getterAvatar.name;
      // @ts-ignore
      // 이미지 파일 초기화
      this.$refs.file.value = '';
      this.$message.success('프로필 사진을 업로드하였습니다.');
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  async deleteUser(): Promise<any> {
    const checkAdmin = await this.c_getterGroupsMemberships.find((group: any) => group.isAdmin);
    if (!!checkAdmin) {
      this.$confirm('Lab 관리자는 멤버로 전환 후 계정삭제가 가능합니다.', `계정 삭제 `, {
        confirmButtonText: 'Lab 관리 바로 가기',
        cancelButtonText: '취소',
        type: 'warning',
      })
        .then(async () => {
          try {
            await this.$router.push({
              name: 'ManageGroup',
              params: {
                groupId: checkAdmin.fkGroup.id,
              },
            });
          } catch (e) {
            console.log(e);
            this.$message.error(e.response.data.error.message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      this.$confirm(
        '계정이 삭제되더라도 Lab 활동기록은 자동삭제되지 않습니다.',
        `계정을 삭제하시겠습니까?`,
        {
          confirmButtonText: '계정삭제',
          cancelButtonText: '취소',
          type: 'warning',
        }
      )
        .then(async () => {
          try {
            await this.c_deleteProfile(this.c_getterAuthUserId);
            await this.c_logOut();
            this.$message.success('계정을 삭제하였습니다.');
          } catch (e) {
            console.log(e);
            this.$message.error(e.response.data.error.message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
}
